import React, { ReactElement, useEffect } from 'react'

import './App.css'

import { Capacitor } from '@capacitor/core'
import { SocialLogin } from '@capgo/capacitor-social-login'
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  LinearScale,
  Title,
  Tooltip,
  LineElement,
  PointElement,
  LineController,
  Filler,
  Legend,
  ArcElement,
} from 'chart.js'
import { useLocation } from 'react-router-dom'

import { appConfig } from './app-config/AppConfig'
// import { useAppUpdater } from './hooks/useAppUpdater'
import { useHideProgressier } from './hooks/useHideProgressierBadge'
import { AppRoutesSettings, RenderRoutes } from './routes'
import { trackGoogleTagPageView } from './services/GoogleTagService'

Chart.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  LineElement,
  PointElement,
  LineController,
  Filler,
  Legend,
  ArcElement,
)

const App = (): ReactElement | null => {
  // useAppUpdater()

  useHideProgressier()
  const { pathname, search } = useLocation()

  useEffect(() => {
    trackGoogleTagPageView(`${pathname}${search}`)
  }, [pathname, search])

  useEffect(() => {
    const platform = Capacitor.getPlatform()
    const providers: Parameters<typeof SocialLogin.initialize>[0] = {
      google: {
        webClientId: appConfig.WEB_CLIENT_ID,
        iOSClientId: appConfig.IOS_CLIENT_ID,
        mode: 'online',
      },
    }

    if (platform === 'ios') {
      providers.apple = {
        clientId: appConfig.APPLE_LOGIN_SERVICE_ID,
      }
    }

    SocialLogin.initialize(providers).catch((error) => {
      // eslint-disable-next-line no-console
      console.error('SocialLogin initialize failed', error)
    })
  }, [])

  return <RenderRoutes routeSettings={AppRoutesSettings} />
}

export default App
